<template>
  <div class="fullscreen" id="poster">
    <div class="login-box" >
      <div class="logo-box">
        <h1>德鲁克贸易河北有限公司</h1>
      </div>
      <form action="" class="login-form">
        <div class="m-list-group">
          <div  class="m-list-group-item" >
            <input type="text" placeholder="请输入用户名" class="m-input" name="phone" v-model="phone">
          </div>
          <div class="m-list-group-item">
            <input type="password" placeholder="请输入密码" class="m-input" name="password" v-model="password">
          </div>
        </div>
        <el-button  class="m-btn sub select-none" @click="handleLogin">登录</el-button>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'login',
    data () {
      return {
        phone:'',
        password:'',
        isLoging: false,
      }
    },mounted() {
    },
    methods: {
      handleLogin(key, value) {
        // if (!this.phone || !this.password) {
        //   return this.$msg.warning('用户名和密码不能为空')
        // }
        this.isLoging = true,
		
	
          this.$inbound.post({
            interfaceId: 'user/login',
            data: {
              tu_phone: this.phone,
              tu_password: this.password
            }
          }).then(response => {
            localStorage.setItem("users",JSON.stringify(response))
            this.$router.replace({
              path: '/admin'
            })
          }).catch(error => {
            alert("请输入正确的账号和密码！")
          })
      }
    }
  }
</script>
<style scoped>
  #poster {
    background: url("../assets/img/loginBlackgroup.jpg") no-repeat center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }

  .m-list-group {
    border-radius: 3px;
    padding: 0;
    margin: 0 0 20px;
  }
  .m-list-group .m-list-group-item {
    position: relative;
    display: block;
    padding: 6px 10px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #e7ecee;
  }
  .m-list-group .m-list-group-item:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .m-list-group .m-list-group-item:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .fullscreen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(-45deg, #f7fafd, #bddeff);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .login-box {
    position: relative;
    width: 330px;
    margin: 0 auto;
    padding: 0px 15px;
    background: #fff;
  }
  .logo-box {
    text-align: center;
  }
  .login-box .logo {
    max-width: 40%;
    width: 120px;
    margin-bottom: 30px;
    text-align: center;
    display: inline-block;
    color: #36c1fa;
  }
  .login-box .text-tips {
    text-align: center;
    color: #909DB7;
  }
  .login-box .m-input {
    width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    box-sizing: border-box;
  }
  .login-box .m-btn {
    font-size: 18px;
    width: 100%;
    color: #fff;
    background-color: #36c1fa;
    display: inline-block;
    padding: 10px 12px;
    margin-bottom: 5px;
    line-height: 1.42857143;
    text-align: center;
    cursor: pointer;
    outline: none;
    border-radius: 2px;
    border: 1px solid #36c1fa;
    box-sizing: border-box;
    text-decoration: none;
  }
  .login-box .m-btn.m-btn-text {
    background: #fff;
    color: #36C1FA;
  }
  .login-box .m-btn:hover{
    background-color: #2DB7F5;
  }
  .login-box .m-btn.m-btn-text:hover {
    background-color: #F4F5F5;
  }
  .login-box .m-btn:active {
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    .login-box{
      width: auto;
    }
  }
</style>
